<div  *ngIf="showCartData">
  <div class="outside-container mt-4">
    <div class="box-container ">
     <div class="container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div></div></div>

</div>
<span *ngIf="!showCartData">
<div *ngIf="airData" class="outside-container mt-4">
  <div class="box-container ">
      <div class="container">
          <div class="title ">

            <div class="row">
              <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
             <div class="col-md-7 d-flex justify-content-center">Modify Cart </div>
             <div class=" col-md-3 row ">
               <div class="d-flex justify-content-end">
                <span *ngIf="userType!='AGENT'">
                <button *ngIf="airData.status==='Z'||airData.status==='B'||airData.status==='X'||airData.status==='C'" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" [matMenuTriggerFor]="showTimeDialog" ><mat-icon>keyboard_arrow_down</mat-icon> Download as PDF </button>
                <mat-menu #showTimeDialog="matMenu"  >
                  <button style="width: 180px;" (click)="generatePDF('C')" mat-menu-item><mat-icon>download</mat-icon>Current</button>
                  <button style="width: 180px;" (click)="generatePDF('O')" mat-menu-item><mat-icon>download</mat-icon>Original</button>

                  </mat-menu>
                </span>
                  <span *ngIf="userType==='AGENT'">
                  <button *ngIf="airData.status==='Z'||airData.status==='B'||airData.status==='X'||airData.status==='C'"  (click)="showSideBar()" class="btn btn-primary mt-1"  >
                    Download
                  </button>
                <!-- <button  class="btn btn-outline-primary btn-sm " (click)="onAddDataEntity()"><img src="assets/images/Add_24.png"></button> -->
                <!-- <p-overlayPanel >
                  <div style="padding: 16px; width: 250px;">
                
                    <div *ngIf="showInput" class="mt-3">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Markup</mat-label>
                        <input matInput [(ngModel)]="inputText" />
                      </mat-form-field>
                
                      <button mat-raised-button color="primary" (click)="updateTicketData()">Update</button>
                    </div>
                  </div>
                
                  <div class="overlay-footer" style="padding: 10px; border-top: 1px solid #ddd; text-align: right;">
                    <mat-checkbox color="primary" [(ngModel)]="pricing">Pricing</mat-checkbox>

                    <button mat-stroked-button color="primary" (click)="downloadAgentTicket('C')">Download</button>
                  </div>
                </p-overlayPanel> -->
              </span>
             </div>
              </div>
            </div>
          
          </div> 
          </div>
          </div>
        </div>
        <div  *ngIf="airData" class="outside-container ">
          <div class="box-container ">
              <div class="container ">
                <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
               
               
                  <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                    <div class="col-md-12 ">
                      <!-- [ngClass]="{'activity' :showItinerary}" -->
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(clientInfo)"  >Client Information</span></span>
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"    (click)="scroll(cartInfo)"   >Cart Information</span></span>
                    <span *ngIf="airData.invoiceData.length!=0" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(PartyInfo)"  >3rd Party Invoicing </span></span>
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(notes)"  >Notes</span></span>

                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(itineraryInfo)"  >Itinerary Information</span></span>
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(contactDetails)"  >Contact Details</span></span>
                    <span *ngIf="airData.airItineraries[0].payment.length>0" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(paymentDetails)"  >Payment Details</span></span>
                    <span *ngIf="airData?.orderPgPaymentData" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(gatewayInfo)"  >Gateway Info</span></span>

                  
                    <span *ngIf="amendCartList.length!=0&&loginUserType!='AGENT'" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(CartAmendments)"  >Cart Amendments</span></span>
                    <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(reportingTags)">Reporting Tags</span></span>
                    <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(whatsapp)">WhatsApp Notifications</span></span>
                    <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(email)">Email Notifications</span></span>
                    <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(Miscellaneous)">Miscellaneous data</span></span>

                    <!-- *ngIf="airData.amendment" -->
                    
                  </div>
                    
                  </div>

                 <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                   <div  class="col-md-12 card" style="min-height: 100%;" >

                    <div  class="  mt-1 " style="padding: 10px; padding-bottom: 380px;">
                     
                      <div #clientInfo class="col-md-12 title"style="max-height: 45px;" >
                          Client Information
                      </div>

                      <div class="col-md-12 " style="overflow:auto">
                       
                          <table class="styled-Upper-table mt-3" style="margin: 0; padding: 0;width: 100%;">
                          
                              <tbody>
                                <!-- Iterate through dynamic data rows -->
                                <tr style="background-color: #f2f2f2;" >
                                  <!-- Display structured data -->
                                 
                                  <td class="name-type" >Client Name	</td>
                                  <td  class="" style="background-color: #ffffff;min-width:300px;">
                                    <!-- Interpret the character and display accordingly -->
                                   {{clientName}}
                            <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                  </td>
                                  <td class="name-type" >Billing Entity	</td>
                                  <td  class="" style="background-color: #ffffff; min-width:300px;">
                                    <!-- Interpret the character and display accordingly -->
                                    {{billingEntity}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                  </td>
                                  
                                </tr>
                               
                                
                              </tbody>
                            </table>  
                        
                        </div>
                        
                        <div #cartInfo class="col-md-12 title mt-2"style="max-height: 50px;" >
                          Cart Information  
                        </div>

                      <div class="col-md-12 " style="overflow:auto">
                       
                          <table class="styled-Upper-table mt-3 " style="margin: 0; padding: 0;width: 100%;">
                          
                              <tbody>
                                <!-- Iterate through dynamic data rows -->
                                <tr style="background-color: #f2f2f2;">
                                  <!-- Display structured data -->
                                  <td class="name-type" >Cart Id</td>
                                  <td  class="" style="background-color: #ffffff;min-width:200px;">
                                   {{airData?.uuid||'-'}}
                                  </td>
                                  <td class="name-type" >Request Id</td>
                                  <td  class="" style="background-color: #ffffff;min-width:200px;">
                                   {{airData?.requestUuid||'-'}}
                                  </td></tr>
                                <tr style="background-color: #f2f2f2;">
                                  <!-- Display structured data -->
                              
                                  <td class="name-type" >Generation Time		</td>
                                  <td  class="" style="background-color: #ffffff;min-width:200px;">
                                    <!-- Interpret the character and display accordingly -->
                                   {{formatDate(airData?.creationTs)||'-'}}
                            <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                  </td>
                                  <td class="name-type" >Booking Status</td>
                                  <td  class="" style="background-color: #ffffff; min-width:200px;">
                                    <!-- Interpret the character and display accordingly -->
                                    <button *ngIf="airData.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                                    <button *ngIf="airData.status==='B'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
                                    <button *ngIf="airData.status==='Z'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                                    <button  *ngIf="airData.status==='F'||airData.status==='P'||airData.status==='S'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                                    <button  *ngIf="airData.status==='R'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PAYMENT FAILED</button>
                                    <button  *ngIf="airData.status==='T'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PENDING TICKET</button>

                                    <button  *ngIf="airData.status==='A'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>ABORTED</button>
                                    <button  *ngIf="airData.status==='TC'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button >TO CANCEL</button>
                                    <button  *ngIf="airData.status==='C'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                                    <button  *ngIf="airData.status==='X'" style="background-color:#ff5e00;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>
                                    <button  *ngIf="airData.status==='CR'" style="background-color:#c70d0d;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
                                    <button  *ngIf="airData.status==='PS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button>Partially Reschedule</button>
                                    <button  *ngIf="airData.status==='RS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button> Rescheduled</button>

                                  </td>
                                 
                                </tr>
                                <tr style="background-color: #f2f2f2; ">
                                  <!-- Display structured data -->
                                  
                                  <td class="name-type" 
                                  >Booked For	</td>
                                  <td  class="" style="background-color: #ffffff; min-width:200px;">
                                    {{airData?.bookedFor||'-'}}  
                                  </td>
                                  <td class="name-type" 
                                  >Booked By	</td>
                                  <td  class="" style="background-color: #ffffff; min-width:200px;">
                                   {{bookedBy||'-'}}  
                                  </td>
                                  
                                </tr>
                               
                              </tbody>
                              <tbody>
                                  <tr style="background-color: #f2f2f2; ">
                                      <!-- Display structured data -->
                                      <td class="name-type" >Booking Time	
                                      </td>
                                      <td  class="" style="background-color: #ffffff; min-width:200px;">
                                        <!-- Interpret the character and display accordingly -->
                                       {{formatDate(airData?.bookingTs)||'-'}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                      </td>
                                        <!-- Display structured data -->
                                        <td class="name-type" >External Trip Id	
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;" >
                                          <div class="row col-md-12">
                                         <div class="col-md-9"> {{airData?.tripId||'-'}}</div>
                                          <!-- <input type="text" class="form-control" > <button class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Update</button> -->
                                        </div>
                                        </td>
                                    
                                    </tr>

                                    <tr style="background-color: #f2f2f2; ">
                                      <!-- Display structured data -->
                                      <td class="name-type" >Emulating User		
                                      </td>
                                      <td  class="" style="background-color: #ffffff; min-width:200px;">
                                        <!-- Interpret the character and display accordingly -->
                                       {{''}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                      </td>
                                      <td class="name-type" >Reseller User		
                                      </td>
                                      <td  class="" style="background-color: #ffffff; min-width:200px;">
                                        <div class="row col-md-12">
                                          <div class="col-md-9"> {{''}}</div>
                                           <button class="col-md-3" (click)="openGstDetail()" mat-flat-button style="background-color:#4986E8;color:white;"> GST&nbsp;Info</button>
                                         </div>
                                      </td>
                                      </tr>
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Payment Status			
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          {{airData?.paymentStatus==='P'?('PAID'):''}}
                                          {{airData?.paymentStatus==='F'?('FAILED'):''}}
                                          {{airData?.paymentStatus==='I'?('INITIATED'):''}}
                                          {{airData?.paymentStatus==='A'?('ABORTED'):''}}
                                          {{airData?.paymentStatus==='U'?('UNPAID'):''}}

                                        </td>
                                        <td class="name-type" >Time Limit			
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          <div class="row col-md-12">
                                            <div class="col-md-9"> <input type="text" class="form-control" placeholder="dd/mm/yyyy"  ></div>
                                             <button class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Update</button>
                                           </div>
                                        </td>
                                      </tr>
                                      

                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        
                                        <td class="name-type" >Locked By/Type		
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          <div class="row col-md-12">
                                            <div class="col-md-12"> {{''}}</div>
                                             <button class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Unlock</button>
                                           </div>
                                        </td>
                                        <td class="name-type" >	
                                          Assigned To	
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{''}}
                                        </td>
                                      </tr>
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Invoice Status			
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          {{airData?.invoiceStatus==='N'?('NEW'):''}}
                                          {{airData?.invoiceStatus==='P'?('PENDING'):''}}
                                          {{airData?.invoiceStatus==='S'?('SUCCESS'):''}}
                                        </td>
                                        <td class="name-type" >Cart Type				
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          {{airData.cartType==='A'?('Auto'):airData.cartType==='M'?('Manual'):''}}
                                        </td>
                                      
                                      </tr>
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Personal Booking			
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{airData.userBookingContext==='P'?('Yes'):'No'}}
                                        </td>
                                        <td class="name-type" >		
                                         <span *ngIf="airData.cartType==='M'&&airData.status==='N'">Create Booking</span> 		
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{''}}

                                         <span *ngIf="airData.cartType==='M'&&airData.status==='N'">
                                          <button  (click)="openManualBooking(airData.uuid)" mat-flat-button style="background-color:#4986E8;color:white;"> Booking Manually </button>

                                         </span>
                                        </td>
                                      
                                      </tr>
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Guest Booking				
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{''}}
                                        </td>
                                        <td class="name-type" >				
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{''}}
                                        </td>
                                      
                                      </tr>
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Cart Status	
                                          		
                                        </td>
                                        <td  class="name-type" style="background-color: #ffffff; min-width:200px;">
                                          <div class="row col-md-12">
                                            <div  class="col-md-7 pt-1"> {{'Open'}}</div>
                                            <span *ngIf="checkShowAbort()">
                                             <button class="col-md-5" mat-flat-button *ngIf="airData.status==='F'||airData.status==='P'||airData.status==='S'" (click)="abortItinerary('A')" style="background-color:#4986E8;color:white;">  <mat-icon style="font-size: 18px;">cancel </mat-icon> Abort</button>
                                             <button class="col-md-5" mat-flat-button *ngIf="airData.status==='Z'" (click)="abortItinerary('V')" style="background-color:#4986E8;color:white;">  <mat-icon style="font-size: 18px;">cancel </mat-icon> Void </button>
                                            </span>
                                           </div>
                                        </td>
                                        <td class="name-type" >				
                                          Booking Platform	
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                         {{airData?.channel||'-'}}
                                        </td>
                                      
                                      </tr>
                                     

                              </tbody>
                            </table>  
                        
                        </div >
                       <span #PartyInfo></span>
                        <div *ngIf="airData.invoiceData.length!=0"  class="col-md-12 title mt-2"style="max-height: 50px;" >
                          3rd Party Invoicing Information</div>

                          <div *ngIf="airData.invoiceData.length!=0" class="col-md-12 mt-3" style="overflow:auto" >
                            <table class="styled-tables col-md-12">
                                <thead>
                                  <tr >
                                    <!-- Dynamic headers based on tableHeaders array -->
                                    <th style="padding: 8px;  text-align: center;">Package Name		</th>
                                    <th style="padding: 8px;  text-align: center;">ID</th>
                                    <th style="padding: 8px;  text-align: center;">Accounts Code	</th>
                                    <th style="padding: 8px;  text-align: center;">Status	</th>
                                    <th style="padding: 8px;  text-align: center;">Failed Attempts	</th>
                                    <th style="padding: 8px;  text-align: center;">Invoice Id	</th>
                                    <th style="padding: 8px;  text-align: center;">Message</th>
                                    <th style="padding: 8px;  text-align: center;">Unique Id	</th>
                                    <th *ngIf="loginUserType==='STAFF'" style="padding: 8px;  text-align: center;">Download Logs		</th>
                                    <th *ngIf="loginUserType==='STAFF'" style="padding: 8px;  text-align: center;">Client Invoice</th>


                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr  *ngFor="let invoice of airData.invoiceData;let i=index">
                                    <!-- Display structured data -->
                                    <td  style="padding: 8px;">{{invoice?.packageName}}</td>
                                    <td  style="padding: 8px;">{{invoice?.id}}</td>
                                    <td  style="padding: 8px;">{{invoice?.accountCode}}</td>
                                    <td  style="padding: 8px;">
                                      {{invoice?.invoiceStatus==='N'?('NEW'):''}}
                                      {{invoice?.invoiceStatus==='P'?('PENDING'):''}}
                                      {{invoice?.invoiceStatus==='S'?('SUCCESS'):''}}
                                      <br>
                                      <span *ngIf="invoice.invoiceStatus==='N'">
                                        <mat-icon  style="color: #4986E8; cursor: pointer;" (click)="refresh()">refresh</mat-icon>

                                      </span>
                                      <span *ngIf="invoice.invoiceStatus==='P'">
                                      <button *ngIf="!invoice.boolean"  mat-flat-button style="background-color:#4986E8;color:white;" (click)="salesDetail(invoice,i)">Push</button>
                                      <mat-spinner *ngIf="invoice.boolean" style="height:30px;width:30px"></mat-spinner>

                                    </span>

                                    </td>
                                    <td  style="padding: 8px;">{{invoice?.failedAttempts}}</td>
                                    <td  style="padding: 8px;">{{invoice?.docNo?(invoice?.docPref+'/'+invoice?.docNo):''}}</td>
                                    <td  style="padding: 8px;"></td>
                                    <td  style="padding: 8px;">{{invoice?.uniqueId}}</td>
                                    <td *ngIf="loginUserType==='STAFF'"  style="padding: 8px;"><button mat-flat-button style="background-color:#4986E8;color:white;" (click)="downloadInvoiceLog(invoice)">Download&nbsp;Invoice&nbsp;Log</button></td>
                                    <td *ngIf="loginUserType==='STAFF'" style="padding: 8px;">
                                      <button *ngIf="!showFinPdF" mat-flat-button style="background-color:#4986E8;color:white;" (click)="downloadFinBookPDF(invoice?.id,invoice?.uniqueId)">Client&nbsp;Invoice</button>
                                      <button *ngIf="showFinPdF&&invoice?.uniqueId===pdfDownloadUrl.uniqueId"  mat-flat-button style="background-color:#4986E8;color:white;min-width: 130px;" >
                                        <mat-spinner  style="height:20px;width:20px"></mat-spinner>
                                      </button>
                                      <button *ngIf="showFinPdF&&invoice?.uniqueId!=pdfDownloadUrl.uniqueId"  mat-flat-button style="background-color:#9bbffa;color:white;min-width: 130px;" >
                                        <!-- <mat-spinner  style="height:20px;width:20px"></mat-spinner> -->
                                        Client&nbsp;Invoice
                                      </button>
                                    </td>

                                  </tr>
                                </tbody>
                              </table>


                    </div> 

                    <div #notes class="col-md-12 title mt-2"style="max-height: 50px;" >
                      Notes</div>

                      <div class="col-md-12 mt-3" style="overflow:auto">
                        <table class="styled-tables ">
                            <thead>
                              <tr >
                                <!-- Dynamic headers based on tableHeaders array -->
                                <th style="padding: 8px;  text-align: center;">Time		</th>
                                <th style="padding: 8px;  text-align: center;">Type</th>
                                <th style="padding: 8px;  text-align: center;">User	</th>
                                <th style="padding: 8px;  text-align: center;">Private	</th>
                                <th style="padding: 8px;  text-align: center;">Note	 
                                 <button  class="btn btn-outline-primary btn-sm " (click)="noteOp.toggle($event);blankNotes()"><img src="assets/images/Add_24.png"></button>
                <p-overlayPanel #noteOp>
                  <div style="padding: 16px; width: 250px;">
                
                    <div  class="">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Notes</mat-label>
                        <textarea matInput [(ngModel)]="notesRequest.notes" ></textarea>
                      </mat-form-field>
                      <mat-checkbox color="primary" [(ngModel)]="notesRequest.scop">Scope</mat-checkbox>

                    </div>
                  </div>
                
                  <div class="overlay-footer" style="padding: 10px; border-top: 1px solid #ddd; text-align: right;">
                    <button  class="btn btn-outline-success c-width-100px shadow "  (click)="saveNotes(noteOp)" [disabled]="!notesRequest.notes||disableNotes">Save</button>

                    <!-- <button mat-stroked-button color="primary" (click)="saveNotes()">Save</button> -->
                  </div>
                </p-overlayPanel>
                                
                                </th>
                               


                              </tr>
                            </thead>
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
                              <tr  *ngFor="let notes of airData.orderNotes">
                                <!-- Display structured data -->
                                <td  style="padding: 8px;">{{formatDate(notes?.genTs)}}</td>
                                <td  style="padding: 8px;">{{notes?.type}}</td>
                                <td  style="padding: 8px;"></td>
                                <td  style="padding: 8px;"></td>
                                <td  style="padding: 8px;">{{notes?.description}}</td>
                               


                              </tr>
                            </tbody>
                          </table>


                </div> 

                      <span #itineraryInfo></span>
           
                  
                       

                        <span *ngFor="let flights of airData.airItineraries">
                          <div  *ngIf="airData && airData.airItineraries.length!=0" class="col-md-12 title mt-2" [style]="flights?.status==='P'?('background-color:#ff5e00;max-height: 50px;'):flights?.status==='CR'?('background-color:#c70d0d;max-height: 50px;'):flights?.status==='C'?('background-color:#e86949e3;max-height: 50px;'):flights?.status==='F'?('background-color:red;max-height: 50px;'):flights?.status==='R'?('background-color:rgb(208, 196, 26);max-height: 50px;'):'max-height: 50px;'" >
                           <div class="col-md-12 row">
                            <div class="col-md-8 d-flex justify-content-end" ><span>{{cityFilter(flights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(flights?.flightDetails?.flightDetailsList[flights?.flightDetails?.flightDetailsList.length-1]?.toAirport)}}</span> &nbsp; <span *ngIf="flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
                         <div class="col-md-4 d-flex justify-content-end">
  <!-- *ngIf="flights.ticketIssuance===true&&flights.docIssuanceStatus==='F'" -->
                          <span  style="font-size: 18px;color: #eaeff5; cursor: pointer;border-radius: 4px; padding: 4px; background-color: #4986E8;"   *ngIf="flights.status==='T'" (click)="syncItinerary(cartUuid,flights?.uuid)">
                            <mat-icon style="font-size: 18px;padding-top: 7px;">cached </mat-icon>Issue ticket</span>
                          <!-- <span> <mat-icon  style="color: #4986E8; cursor: pointer;" (click)="patchItinerary(cartUuid,flights?.uuid)">refresh</mat-icon></span> -->
  
                         </div>
                          </div>                 
                          </div>
  
                        <div class="col-md-12 row" *ngIf="airData&& airData.airItineraries.length!=0">
  
                            <div class="flights pt-3" *ngFor="let item of flights?.flightDetails?.flightDetailsList">
                                <div class="flight-details">
                                  <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                   
                                  <div class="carrier-info">
                                    <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                    <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                  </div>
                                </div>
                                <svg class="line" width="1200" height="100" >
                                    
                                    <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                    <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                    <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
            
                                    <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                    <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
              
                                    <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                  </svg>
                                
  
                                 
                              </div>
                              <div class="col-md-12 mt-3" style="overflow:auto">
                                <table class="styled-tables ">
                                    <thead>
                                      <tr >
                                        <!-- Dynamic headers based on tableHeaders array -->
                                        <th style="padding: 8px;  text-align: center;">Passenger</th>
                                        <th style="padding: 8px;  text-align: center;">Status</th>
                                        <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                        <th style="padding: 8px;  text-align: center;">CRS PNR</th>
                                        <!-- <th style="padding: 8px;  text-align: center;">Passive PNR		</th> -->
  
                                        <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                        <th style="padding: 8px;  text-align: center;">B.Class</th>
  
                                        <th style="padding: 8px;  text-align: center;">Fare Basis</th>
                                        <th style="padding: 8px;  text-align: center;">Misc. Data</th>
                                        <th  style="padding: 8px;  text-align: center;">Select</th>
  
    
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <!-- Iterate through dynamic data rows -->
                                      <ng-container *ngFor="let passengerDetail of flights?.orderPassengerDetails; let i = index">
  
                                      <tr [style]="passengerDetail?.pnrStatus==='HL'?('background-color:#FFD700'):passengerDetail?.pnrStatus==='SC'?('background-color:rgb(208, 196, 26)'):passengerDetail?.pnrStatus==='HX'?('background-color:#e86949e3'):passengerDetail?.pnrStatus===null?('background-color:red'):passengerDetail?.pnrStatus==='CR'?('background-color:#c70d0d'):''">
                                        <!-- Display structured data -->
                                        <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                       ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                       <td  style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                                       <td class="" style="padding: 8px;">
                                        <input *ngIf="flights.flightDetails.source==='GALELIO'" type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):'-'">
                                        <input *ngIf="flights.flightDetails.source!='GALELIO'" type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail?.pnr">
                                      </td>
                                        <td class="name-type" style="padding: 8px;">
                                          <mat-icon *ngIf="!passengerDetail.csrPNR" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">refresh</mat-icon>
                                          <input *ngIf="passengerDetail.csrPNR" type="text" class="form-control col-md-12" [(ngModel)]="passengerDetail.csrPNR">
                                        </td>
                                        <!-- <td class="name-type" style="padding: 8px;"><input type="text"  class="col-md-12 form-control"></td> -->
  
                                        <td class="name-type" style="padding: 8px;">
                                          <span *ngIf="passengerDetail.ticketNumber&&flights.flightDetails.source!='GALELIO'">{{passengerDetail?.ticketNumber===0?(''):passengerDetail?.ticketNumber?(passengerDetail?.ticketNumber):''}}</span>
                                          <input *ngIf="flights.flightDetails.source==='GALELIO'" type="text" (keypress)="onlyNumberKey($event)"  class="col-md-12 form-control" [(ngModel)]="passengerDetail.ticketNumber">
                                          <mat-icon  *ngIf="flights.flightDetails.source==='GALELIO'&&passengerDetail.pnrStatus==='HK'||flights.flightDetails.source==='GALELIO'&&passengerDetail.pnrStatus==='OK'" style="color: #4986E8; cursor: pointer;" (click)="patchPerPassengerItinerary(cartUuid,flights?.uuid,passengerDetail)">upload</mat-icon>
  
                                        </td>
                                        <td class="name-type" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail?.fareDetails?.passengerBookingClasses[0]?.bookingClass"></td>
                                        <td class="" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareBasis"></td>
                                        <td class="name-type" style="padding: 8px;"> 
                                          <button *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" mat-flat-button style="background-color:#4986E8;color:white;" (click)="onShowMiscellaneous(cartUuid,flights?.uuid,passengerDetail,flights.flightDetails.source)">Update</button>
                                        </td>
                                        <td  class="name-type" style="padding: 8px;">
                                          <mat-checkbox *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" color="primary"[(ngModel)]='passengerDetail.showAction' (click)="itinerarySelect(passengerDetail,flights)"></mat-checkbox>
                                        </td>
  
    
                                      </tr>
  
                                      <tr *ngIf="i < flights?.orderPassengerDetails.length">
                                        
                                          <td colspan="10" style="text-align: left; padding-left: 4px; font-size: small;color: gray;">
  <div *ngIf="flights?.ticketingTimeLimit" class="news-ticker-wrapper">
  <div class="news-ticker">
    <span>
      <strong>
        {{flights?.ticketingTimeLimit ? (flights?.ticketingTimeLimit) : ''}} 
      </strong>
    </span>
  </div>
</div>
                                            <!-- <span><strong style="color: #e86e49;">{{flights?.ticketingTimeLimit?(flights?.ticketingTimeLimit):''}} To https://bitbucket.org/kishanlinuxmantra/pragyan-ui.git</strong><br><br></span> -->

                                            <span *ngIf="userType!='EMPLOYEE'"><strong style="color: #4986E8;">{{passengerDetail?('Fare Detail:'):''}}</strong><span [innerHTML]="displayJSON(passengerDetail.fareDetails.passengerBookingClasses)"></span><br><br></span>
                                            <strong style="color: #4986E8;">{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong><span [innerHTML]="displayWEJSON(passengerDetail?.seatMeal?.seatMeal)"></span><br><br>
                                            <span *ngIf="userType!='EMPLOYEE'"><strong style="color: #4986E8;">{{flights.supplierPayment?('Supplier Payment:'):''}}</strong><span [innerHTML]="displayWEJSON(flights.supplierPayment)"></span><br><br></span>
                                            <strong style="color: #4986E8;">{{flights?.commissionData?('Service Charges:'):''}}</strong><span [innerHTML]="displaymarkcommJSON(flights?.commissionData)"></span><br><br>
                                            <span *ngIf="userType!='EMPLOYEE'"><strong style="color: #4986E8;">{{flights?.externalMarkUpData?('Markup Data:'):''}}</strong><span [innerHTML]="displaymarkcommJSON(flights?.externalMarkUpData)"></span></span></td>


                                      </tr>
  </ng-container>
                                    
                                    </tbody>
                                  </table>
    
                                  <table class="styled-tables " *ngIf="flights.showAction">
                                    <thead>
                                
                                    </thead>
                                    <tbody>
                                      <!-- Iterate through dynamic data rows -->
  
                                      <tr>
                                        <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Air Items	</td>
                                        <td  style="padding: 8px;width:35%" >
                                          <div class="row col-md-12">
                                          <div class="col-md-6 d-flex justify-content-center">
                                          <div class="col-md-12 ">
                                            <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',flights?.flightDetails?.flightDetailsList[0],flights?.flightDetails?.flightDetailsList[flights?.flightDetails?.flightDetailsList.length-1]?.toAirport,flights?.orderPassengerDetails[0].pnr,selectedPnr,PassengerObject)">Cancel</button>
  
                                          <!-- <mat-select class="form-control" [(ngModel)]="amendSelect" name="amend">
                                         <mat-option class="mat-primary" value="cancel">Cancel</mat-option>
                                         <mat-option class="mat-primary" value="reschedule">Reschedule</mat-option>
                                         
  
                                        </mat-select> -->
                                      </div>
                                    </div>
                                        <div class="col-md-6 ">
                                          <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',flights?.flightDetails?.flightDetailsList[0],flights?.flightDetails?.flightDetailsList[flights?.flightDetails?.flightDetailsList.length-1]?.toAirport,flights?.orderPassengerDetails[0]?.pnr,selectedPnr,PassengerObject)">Reschedule</button>
  
                                        </div>
                                      </div>
                                      
                                        </td>
  
                                      </tr>
                                    </tbody>
                                  </table>
    
                        </div> 
                             
                             
        
  
  
   
                          
                          </div>
                          </span>


                        <div #contactDetails class="col-md-12 title mt-2"style="max-height: 50px;" >
                          Passenger Contact Details</div>

                          <div class="col-md-12 mt-3" >
                            <table class="styled-tables ">
                                <thead>
                                  <tr >
                                    <!-- Dynamic headers based on tableHeaders array -->
                                    <th style="padding: 8px;  text-align: center;">Mobile		</th>
                                    <th style="padding: 8px;  text-align: center;">Email Address		</th>
                                    <th style="padding: 8px;  text-align: center;">Postal Address		</th>
                                    <th style="padding: 8px;  text-align: center;">Send Details</th>
                                    


                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr >
                                    <!-- Display structured data -->
                                    <td  style="padding: 8px;">{{airData?.contactNumber}}</td>
                                    <td  style="padding: 8px;">{{airData?.email}}</td>
                                    <td style="padding: 8px;"></td>
                                    <td  style="padding: 8px;">
                                      <!-- <button mat-flat-button style="background-color:#4986E8;color:white;margin-right: 6px;">SMS</button> -->
                                      <button mat-flat-button style="background-color:#4986E8;color:white;margin-right: 6px;" (click)="whatsApp(airData?.contactNumber)">WhatsApp</button>
                                      <button mat-flat-button style="background-color:#4986E8;color:white;" (click)="emailSend(airData?.email)">Email</button>
                                    </td>
                                   


                                  </tr>
                                </tbody>
                              </table>


                    </div> 

                  <span #paymentDetails></span>
                    <div   *ngIf="airData.airItineraries[0].payment.length>0&&checkCharge()"
                    class="col-md-12 title mt-2"style="max-height: 50px;" >
                      Payment Details Charge
                    </div>

                      <div *ngIf="airData.airItineraries[0].payment.length>0&&checkCharge()" class="col-md-12 mt-3" style="overflow:auto">
                        <div *ngFor="let payments of airData.airItineraries">
                          <span *ngIf="checkIteCharge(payments)">

                         <div class="d-flex justify-content-start bold"> {{cityFilter(payments.fromSource)}}-{{cityFilter(payments.toDestination)}}</div>
                        <table class="styled-tables col-md-12">
                            <thead>
                              <tr >
                                <!-- Dynamic headers based on tableHeaders array -->
                                <th style="padding: 8px;  text-align: center;">Payment Id			</th>
                                <th style="padding: 8px;  text-align: center;">Payment Time	</th>
                                <th style="padding: 8px;  text-align: center;">Reason		</th>
                                <th style="padding: 8px;  text-align: center;">Medium		</th>	
                                <th style="padding: 8px;  text-align: center;">Operation	</th>
                                <th style="padding: 8px;  text-align: center;">Amend Id	</th>
                                <th style="padding: 8px;  text-align: center;">Amount		</th>
                                <th style="padding: 8px;  text-align: center;">GST			</th>
                                <th style="padding: 8px;  text-align: center;">TDS Amount			</th>
                                <th style="padding: 8px;  text-align: center;">Status			</th>
                                <!-- <th style="padding: 8px;  text-align: center;">Adhoc Refund				</th> -->
                                <!-- <th style="padding: 8px;  text-align: center;">Payment Receipt</th> -->



                              </tr>
                            </thead>
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
                              <tr *ngFor="let payment of checkOperationCharge(payments.payment)">
                                <!-- Display structured data -->
                                <td  style="padding: 8px;">{{payment?.uuid}}</td>
                                <td  style="padding: 8px;">{{formatDate(payment?.creationTs)}}</td>
                                <td  style="padding: 8px;">{{payment?.reason}}</td>
                                <td  style="padding: 8px;" style="  text-transform:capitalize;">{{payment?.medium}}</td>
                                <td  style="padding: 8px;">{{payment?.operation}}</td>
                                <td  style="padding: 8px;">{{payment?.amendmentId}}</td>
                                <td  style="padding: 8px;">{{payment?.amount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.gstAmount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.tdsAmount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.status}}</td>
                                <!-- <td  style="padding: 8px;">{{''}}</td> -->
                                <!-- <td  style="padding: 8px;"><button mat-flat-button style="background-color:#4986E8;color:white;">Receipt</button></td> -->


                              </tr>
                            </tbody>
                          </table>
                              </span>
                        </div>
                    

                       

                </div> 
                <div   *ngIf="airData.airItineraries[0].payment.length>0&&checkRefund()"
                    class="col-md-12 title mt-2 "style="max-height: 50px;" >
                    <div class="row">
                    <div class="col-md-8 d-flex justify-content-end" >Payment Details Refund</div>  
                    <div class="col-md-4 d-flex justify-content-end">
                      <button *ngIf="checkReverseButton()"   mat-flat-button (click)="RefundPayment()" style="background-color:#4986E8;color:white;">  <mat-icon style="font-size: 18px;">sync </mat-icon> Reverse</button>


                    </div>  
</div>
                    </div>
                <div *ngIf="airData.airItineraries[0].payment.length>0&&checkRefund()" class="col-md-12 mt-3" style="overflow:auto">
                        <div *ngFor="let payments of airData.airItineraries">
                          <span *ngIf="checkIteRefund(payments)">
                         <div class="d-flex justify-content-start bold"> {{cityFilter(payments.fromSource)}}-{{cityFilter(payments.toDestination)}}</div>
                        <table class="styled-tables col-md-12">
                            <thead>
                              <tr >
                                <!-- Dynamic headers based on tableHeaders array -->
                                <th style="padding: 8px;  text-align: center;">Payment Id			</th>
                                <th style="padding: 8px;  text-align: center;">Payment Time	</th>
                                <th style="padding: 8px;  text-align: center;">Reason		</th>
                                <th style="padding: 8px;  text-align: center;">Medium		</th>	
                                <th style="padding: 8px;  text-align: center;">Operation	</th>
                                <th style="padding: 8px;  text-align: center;">Amend Id	</th>
                                <th style="padding: 8px;  text-align: center;">Amount		</th>
                                <th style="padding: 8px;  text-align: center;">GST			</th>
                                <th style="padding: 8px;  text-align: center;">TDS Amount			</th>
                                <th style="padding: 8px;  text-align: center;">Status			</th>
                                <!-- <th style="padding: 8px;  text-align: center;">Action				</th> -->
                                <!-- <th style="padding: 8px;  text-align: center;">Payment Receipt</th> -->



                              </tr>
                            </thead>
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
                              <tr *ngFor="let payment of checkOperationRefund(payments.payment)">
                                <!-- Display structured data -->
                                <td  style="padding: 8px;">{{payment?.uuid}}</td>
                                <td  style="padding: 8px;">{{formatDate(payment?.creationTs)}}</td>
                                <td  style="padding: 8px;">{{payment?.reason}}</td>
                                <td  style="padding: 8px;" style="  text-transform:capitalize;">{{payment?.medium}}</td>
                                <td  style="padding: 8px;">{{payment?.operation}}</td>
                                <td  style="padding: 8px;">{{payment?.amendmentId}}</td>
                                <td  style="padding: 8px;">{{payment?.amount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.gstAmount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.tdsAmount}}&nbsp;INR</td>
                                <td  style="padding: 8px;">{{payment?.status}}</td>
                                <!-- <td  style="padding: 8px;">
                             <button class="col-md-5" mat-flat-button (click)="RefundPayment()" style="background-color:#4986E8;color:white;">  <mat-icon style="font-size: 18px;">sync </mat-icon> Reverse</button>

                                </td> -->
                                <!-- <td  style="padding: 8px;"><button mat-flat-button style="background-color:#4986E8;color:white;">Receipt</button></td> -->


                              </tr>
                            </tbody>
                          </table>
                        
                          </span>

                        </div>

                       

                </div> 
                <span #gatewayInfo></span>
                <div    *ngIf="airData?.orderPgPaymentData"
                class="col-md-12 title mt-2"style="max-height: 50px;" >


                <div class="row">
                <div class="col-md-8 d-flex justify-content-end" >
                Gateway Info
                    </div>  
                    <div class="col-md-4 d-flex justify-content-end">
                      <button  (click)="viewGatewayPayment(airData?.orderPgPaymentData)"   mat-flat-button  style="background-color:#4986E8;color:white;">  View</button>


                        <p-dialog  header="Gateway Info" [modal]="true" [(visible)]="viewGatewayInfo" [style]="{ width: '45rem', height:'55rem' }">

                  <div *ngIf="showGatewaySpinner" style="padding: 16px; width: 250px;">
                
                    <div  class="mt-3">
                        <!-- <mat-label></mat-label> -->
  <mat-progress-bar  mode="indeterminate"></mat-progress-bar>

                    </div>
                  </div>
                
                  <div *ngIf="paymentGatewayDetails&&!showGatewaySpinner" class="payment-container">
  <h2>Payment Summary</h2>
  <div class="payment-details">
    <div><strong>Order ID:</strong> {{ paymentGatewayDetails?.orderId }}</div>
    <div><strong>Status:</strong> {{ paymentGatewayDetails?.status }}</div>
    <div><strong>Amount:</strong> ₹{{ paymentGatewayDetails?.orderAmount }}</div>
    <div><strong>Customer ID:</strong> {{ paymentGatewayDetails?.customerId }}</div>
    <div><strong>Payment Status:</strong> {{ paymentGatewayDetails?.payStatus }}</div>
    <div><strong>Payment Channel:</strong> {{ paymentGatewayDetails?.paymentChannel }}</div>
    <div><strong>Card Number:</strong> {{ paymentGatewayDetails?.maskedCardNumber }}</div>
    <div><strong>Timestamp:</strong> {{ paymentGatewayDetails?.orderTimestamp | date:'medium' }}</div>
  </div>

  <h3>Refund Details</h3>
  
  <div class="refund-list" *ngFor="let refund of paymentGatewayDetails?.refunds||[]">
    <div class="refund-card" [ngClass]="{'failed': refund?.status === 'F'}">
      <div><strong>Refund ID:</strong> {{ refund?.uniqueRequestId }}</div>
      <div><strong>Amount:</strong> ₹{{ refund?.refundAmount }}</div>
      <div><strong>Status:</strong> 
        <span [ngClass]="{'success-text': refund?.status === 'S', 'fail-text': refund?.status === 'F'}">
          {{ refund?.status === 'S' ? 'Success' : 'Failed' }}
        </span>
      </div>
      <div><strong>Remarks:</strong> {{ refund?.refundRemarks }}</div>
      <div><strong>Timestamp:</strong> {{ refund?.refundTimestamp | date:'medium' }}</div>
      <div *ngIf="refund?.failReason"><strong>Fail Reason:</strong> {{ refund?.failReason }}</div>
    </div>
  </div>
  
</div>

</p-dialog>                      <button *ngIf="airData?.orderPgPaymentData?.refundableAmt&&!airData?.orderPgPaymentData?.refundedAmt"   mat-flat-button (click)="RefundGatewayPayment()" style="background-color:#4986E8;color:white;margin-left: 4px;">  <mat-icon style="font-size: 18px;">sync </mat-icon> Refund</button>


                    </div>  
</div>
                </div>
                <div  *ngIf="airData?.orderPgPaymentData" class="payment-info-box"  >

                  <div *ngIf="airData?.orderPgPaymentData?.cardNumber" class="payment-row">
                    <strong>Card Number : </strong> <span> {{ airData?.orderPgPaymentData?.cardNumber }} </span>
                  </div>
                 
                  <div *ngIf="airData?.orderPgPaymentData?.pgOrderId" class="payment-row">
                    <strong>PG Order ID : </strong> <span> {{ airData.orderPgPaymentData?.pgOrderId }} </span>
                  </div>
                  <div *ngIf="airData?.orderPgPaymentData?.status" class="payment-row">
                    <strong>Status : </strong> <span> {{ airData?.orderPgPaymentData?.status }} </span>
                  </div>
                
                  
                  
                 
                </div>
<div *ngIf="airData?.orderPgPaymentData" class="payment-info-box"  >

                
                  <div *ngIf="airData?.orderPgPaymentData?.refundableAmt" class="payment-row">
                    <strong>Refundable Amount : </strong> <span> {{ airData?.orderPgPaymentData?.refundableAmt }} INR</span>
                  </div>
                  <div *ngIf="airData?.orderPgPaymentData?.refundedAmt" class="payment-row">
                    <strong>Refunded Amount : </strong> <span> {{ airData?.orderPgPaymentData?.refundedAmt }} INR</span>
                  </div>
                  <div *ngIf="airData?.orderPgPaymentData?.amt" class="payment-row">
                    <strong>Amount : </strong> <span> {{ airData?.orderPgPaymentData?.amt }} INR </span>
                  </div>
                  
                  
                 
                </div>

                <span #CartAmendments></span>
                <!-- *ngIf="airData.amendment" -->
                <div   *ngIf="amendCartList.length!=0&&loginUserType!='AGENT'"
                class="col-md-12 title mt-2"style="max-height: 50px;" >
                  Cart Amendments
                </div>

                  <div *ngIf="amendCartList.length!=0&&loginUserType!='AGENT'"  class="col-md-12 mt-3" style="overflow:auto">
                    <table class="styled-tables col-md-12">
                        <thead>
                          <tr >
                            <!-- Dynamic headers based on tableHeaders array -->
                            <th style="padding: 8px;  text-align: center;"> Id			</th>
                            <th style="padding: 8px;  text-align: center;">Reference Id</th>
                            <th style="padding: 8px;  text-align: center;">Generation Time		</th>
                            <th style="padding: 8px;  text-align: center;">Processed By		</th>	
                            <th style="padding: 8px;  text-align: center;">Type	</th>
                            <th style="padding: 8px;  text-align: center;">Booking Type	</th>
                            <th style="padding: 8px;  text-align: center;">Status/Approval		</th>
                            <th style="padding: 8px;  text-align: center;">Payment			</th>
                            <th style="padding: 8px;  text-align: center;">Action			</th>



                          </tr>
                        </thead>
                        <tbody>
                          <!-- Iterate through dynamic data rows -->
                          <tr *ngFor="let amend of amendCartList">
                            <!-- Display structured data -->
                            <td  style="padding: 8px;">{{amend?.uuId}}</td>
                            <td  style="padding: 8px;">{{amend?.refId}}</td>
                            <td  style="padding: 8px;">{{formatDate(amend?.genTs)}}</td>
                            <td  style="padding: 8px;">{{amend?.processedBy}}</td>
                            <td  style="padding: 8px;">{{amend?.type}}</td>
                            <td  style="padding: 8px;">{{amend?.bookingType==='A'?('Automation'):''}}</td>
                            <td  style="padding: 8px;">{{amend?.status==="C"?("PROCESSED"+'/'):amend?.status==="I"?("INITIATED"+'/'):''}}{{amend?.approvalStatus}}</td>
                            <td  style="padding: 8px;">{{amend?.payment}}</td>
                            <td  style="padding: 8px;" >
                              <button mat-flat-button *ngIf="amend.status==='I'" style="background-color:#4986E8;color:white;" (click)="onClickAmendPro(amend)">Process</button>
                              <button mat-flat-button *ngIf="amend.status==='C'" style="background-color:#9fb6dc;color:white;cursor: not-allowed;" >Process</button>

                            </td>




                          </tr>
                        </tbody>
                      </table>


            </div> 

            <div class="col-md-12 mt-4"  >
              <div  class="col-md-12 card"  >

               <div  class="  mt-1 " style="padding: 10px; ">
                
                 <div #reportingTags class="col-md-12 title"style="max-height: 45px;" >
                     Reporting Tags
                 </div>

                 <div class="col-md-12 " style="overflow-y:auto">
                  <span   *ngFor="let rmtags of passengerDetails(airData.airItineraries[0].orderPassengerDetails);let i=index">
                    <div style="padding: 4px;" style="text-align: left;" class="name-type mt-2">Adult {{i+1}}</div>
                     <table  class="styled-tables mt-3" style="margin: 0; padding: 0;width: 100%;">
                      <!-- <thead>
                        <tr >
 <th class="name-type">Name</th>
<th class="name-type">Display Name</th>
<th class="name-type">Value</th>
<th class="name-type">Invoiceable</th>

                        </tr>
                      </thead> -->

                         <tbody>
                           <!-- Iterate through dynamic data rows -->
                          <ng-container *ngFor="let tags of rmtags?.rmTags?.rmTagsList">
                           <tr *ngIf="tags.fieldType!='F'" style="background-color: #f2f2f2;"  >
                             <!-- Display structured data -->
                            
                              <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                  <span  *ngIf="tags.fieldType!='F'">
                                  {{tags.value}}
                                  </span>
                                  
                                  </td>
                                </tr>
                                <tr *ngIf="tags.fieldType==='F'&&tags.value!='NA'" style="background-color: #f2f2f2;"  >
                                  <!-- Display structured data -->
                                 
                                   <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                     <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                      
                                       <span>
                                         <button *ngIf="tags.value&&tags.value!='NA'"  mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" (click)="downloadTags(tags.value)">Download</button>
                                       </span>
                                       </td>
                                     </tr>
                              </ng-container>

                           
                         </tbody>
                       </table>  
                      </span>
                    <div *ngIf="airData.rmApprovalUpload">
                      <span   *ngFor="let rmtags of passengerDetails(airData.airItineraries[0].orderPassengerDetails);let i=index">
                         <table *ngIf="i===0" class="styled-tables mt-3" style="margin: 0; padding: 0;width: 100%;">
                       
                             <tbody>
                              <ng-container  *ngFor="let tags of rmtags?.rmTags?.rmTagsList">
                               <tr *ngIf="tags.fieldType==='F'" style="background-color: #f2f2f2;" >                                
                                  <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                    <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                     
                                      <span >
                                        <button   mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" (click)="downloadTags(airData.rmApprovalUpload)">Download</button>
                                      </span>
                                      </td>
                                    </tr>
                                  </ng-container>
    
                               
                             </tbody>
                           </table>  
                          </span>
                          </div>
                       

</div>






</div>

</div>

<div #whatsapp class="col-md-12 title mt-2"style="max-height: 45px;" >
  WhatsApp Notifications
</div>
<table class="styled-tables ">
  <thead>
    <tr >
      <!-- Dynamic headers based on tableHeaders array -->
      <th style="padding: 8px;  text-align: center;">Recipient	</th>
      <th style="padding: 8px;  text-align: center;">Status</th>
      <th style="padding: 8px;  text-align: center;">Channel</th>
      <th style="padding: 8px;  text-align: center;">Creation Date	</th>

      


    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let AppDetail of whatsAppData;let i=index">
    <!-- Iterate through dynamic data rows -->
    <tr >
      <!-- Display structured data -->
     
        <td class="" style="padding: 8px;">{{AppDetail?.recipient}}</td>
         <td class="" style="padding: 8px;">{{AppDetail?.responseData?.messages[0]?.message_status==='accepted'?('Send'):AppDetail?.responseData?.messages[0]?.message_status===null?('Pending'):'Failed'}}</td>
         <td class="" style="padding: 8px;">{{AppDetail?.channel}}</td>
         <td class="" style="padding: 8px;">{{AppDetail?.createdTs}}</td>

         
    </tr>
    <tr *ngIf="i < whatsAppData.length">
      <td colspan="5" style="text-align: left; padding-left: 4px;font-size: small;color: gray;"><span [innerHTML]="displayWEJSON(AppDetail?.requestData)"></span> </td>
      
    </tr>
  </ng-container>
   
  </tbody>
</table>
<div #email class="col-md-12 title mt-2"style="max-height: 45px;" >
  Email Notifications
</div>
<table class="styled-tables ">
  <thead>
    <tr >
      <!-- Dynamic headers based on tableHeaders array -->
      <th style="padding: 8px;  text-align: center;">Recipient	</th>
      <th style="padding: 8px;  text-align: center;">Status</th>
      <th style="padding: 8px;  text-align: center;">Channel</th>
      <th style="padding: 8px;  text-align: center;">Creation Date	</th>

      


    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let AppDetail of emailData;let i=index">
    <!-- Iterate through dynamic data rows -->
    <tr >
      <!-- Display structured data -->
     
        <td class="" style="padding: 8px;">{{AppDetail?.recipient}}</td>
         <td class="" style="padding: 8px;">{{''}}</td>
         <td class="" style="padding: 8px;">{{AppDetail?.channel}}</td>
         <td class="" style="padding: 8px;">{{AppDetail?.createdTs}}</td>

         
    </tr>
    <tr *ngIf="i < emailData.length">
      <td colspan="5" style="text-align: left; padding-left: 4px;font-size: small;color: gray;"><pre [innerHTML]="AppDetail?.requestData"></pre></td>
      
    </tr>
  </ng-container>
   
  </tbody>
</table>
<div #Miscellaneous class="col-md-12 title mt-2"style="max-height: 45px;" >
  Miscellaneous Data
</div>

</div>



                    </div>
                   
                  </div>
                  </div>
              </div>

              <div class="modal " id="myMod"  [style.display]="showGSTPopup ? 'block' : 'none'" >
                <div class="modal-dialog" >
                    <div class="modal-content " >
                        <div class="modal-header title">
                          <h4  class="modal-title">GST Details</h4>

                          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                          </div>
                          <div class="modal-body">
                          <div class="col-md-12 mt-3 " *ngIf="showGSTPopup">
                            <div class="col-md-12 d-flex justify-content-center" >
                            <div class="col-md-12 row " >
                                <div class=" col-md-12 " style="overflow: auto; max-height:60vh ;">
                                    <form [formGroup]="GstRegFg"   autocomplete="off"  class=" row" >
                                     

                                      <div class="col-md-12 title mb-2" style="max-height:45px">
                                        To GST Details
                                      </div>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label> To State	</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>To GST number		</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>To GST email			</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>To GST Name			</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>To GST Address			</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>To GST Phone		</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>

                                      <div class="col-md-12 title mb-2" style="max-height:45px">
                                        From GST Details
                                      </div>

                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>From State				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>From GST number				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>From GST Name			</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>From GST Address		</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>From GST Phone			</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <div class="col-md-12 title mb-2 " style="max-height:45px">
                                        Customer GST Details
                                      </div>


                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer State				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer GST number				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer GST email				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer GST Name				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer GST Address				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                      <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>Customer GST Phone				</mat-label>
                                        <input matInput type="text"  name="name"  autocomplete="off" >

                                      </mat-form-field>
                                     <div class="col-md-12 " style="text-align: left;">
                                          <mat-label class="bold col-md-12">Information to be passed to the service provider?
                                          </mat-label>    
                                          
                                          <mat-selection-list  class="col-md-12 " [multiple]="false"  #PaymentType   style="text-align: left;">
                                            <mat-list-option    class="col-md-12 d-flex justify-content-start"   [color]="'primary'" checkboxPosition="before"><span  >From GST</span>
                                            </mat-list-option>
                                            <mat-list-option    class="col-md-12 d-flex justify-content-start"   [color]="'primary'" checkboxPosition="before"><span >To GST</span>
                                            </mat-list-option>
                                          <mat-list-option     class="col-md-12 d-flex justify-content-start"  [color]="'primary'" checkboxPosition="before"><span  >Customer GST</span>
                                          </mat-list-option>
                                          <mat-list-option    class="col-md-12 d-flex justify-content-start"  [color]="'primary'" checkboxPosition="before"><span  >None</span>
                                          </mat-list-option>
                                         
                                            </mat-selection-list>
                                          </div>
                                      </form>
                                </div>
                                </div>
                                </div>                                      
                          </div>

                            <div class="modal-footer">
                             
                              <button  class="btn btn-outline-success c-width-100px shadow "   [disabled]="GstRegFg.invalid">Update</button>

                            <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                       
                            </div>
                          </div>
                          </div>
                  </div>
              </div>
              <div *ngIf="showNewWhatsApp" class="popup-overlay" >
               
                <div class="popup-container">
                  <div class="modal-header ">
                    <h6  class="modal-title">WhatsApp Number</h6>
  
                    <button type="button" class="close" data-dismiss="modal" (click)="closedPopup()">&times;</button>
                    </div>
                  <input type="text" class="form-control" (input)="validateInput()" (keypress)="onlyNumberKey($event)" [(ngModel)]="WhatsAppNumber" minlength="10" maxlength="10" placeholder="Mobile No...">
                  <button  (click)="SendNewNo(WhatsAppNumber)"  class="btn btn-outline-success c-width-100px shadow mt-1" [disabled]="!isInputValid" >Send</button>
                </div>
              </div>


              <div *ngIf="showNewEmail" class="popup-overlay" >
               
                <div class="popup-container">
                  <div class="modal-header ">
                    <h6  class="modal-title">Email Id</h6>
  
                    <button type="button" class="close" data-dismiss="modal" (click)="closedPopup()">&times;</button>
                    </div>
                  <input type="text" class="form-control"   [(ngModel)]="emailId"  placeholder="Email Id...">
                  <button  (click)="SendEmailNewNo(emailId)"  class="btn btn-outline-success c-width-100px shadow mt-1" [disabled]="!validateEmailInput(emailId)" >Send</button>
                </div>
              </div>




              <div class="modal " id="myMod"  [style.display]="showAmend ? 'block' : 'none'" >
                <div class="modal-dialog" >
                    <div class="modal-content " >
                        <div class="modal-header title">
                          <h4  class="modal-title">Amendment Remarks 
                          </h4>
                          <!-- <small style="color: red;">(Cancellation will be processed for all the Passengers)</small> -->
                          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                          </div>
                          <div class="modal-body">
                          <div class="col-md-12 mt-3 mb-2 row" *ngIf="showAmend">
                      
                            <div class="col-md-5 bold d-flex justify-content-start">
                              Amendment Type:
                            </div>
                            <div class="col-md-6 d-flex justify-content-start">
                             {{amendmentType}}
                            </div>

                            <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                              Sector:
                            </div>
                            <div class="col-md-6 d-flex justify-content-start">
                             <div  ><span>{{cityFilter(sector.fromAirport)}}</span><span style="padding-left: 5px; padding-right: 5px;">To</span><span>{{cityFilter(sectorlastflight)}}</span> <span  style="color: rgb(150, 144, 144);"> {{dateFormate(sector?.schDepartureTime)}}</span></div>

                            </div>

                            <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                              Comment:
                            </div>
                            <div class="col-md-6">
                             <div  > <textarea  type="text" class="form-control" [(ngModel)]="comment"  rows="1"   name="description"  ></textarea>
                             </div>

                            </div>
                            <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                                
                            </div>
                            <div *ngIf="amendmentType==='Cancel'" class="col-md-6 d-flex justify-content-start mt-1 bold">
                              <input type="checkbox" style="width: 15px;height:15px;margin-top: 4px;"  [(ngModel)]="manualCancellation" > &nbsp; Manual Cancellation :

                            </div>
                            <div *ngIf="amendmentType!='Cancel'"  class="col-md-6 d-flex justify-content-start mt-1 bold">
                              <input type="checkbox" style="width: 15px;height:15px;margin-top: 4px;"  [(ngModel)]="manualreschedule" > &nbsp;Manual Reschedule :

                            </div>
                            
                          </div>
                         

                            <div class="modal-footer">
                             
                              <button *ngIf="amendmentType==='Cancel'" class="btn btn-outline-success c-width-100px shadow " [disabled]="confirmDisabled" (click)="cancel()">Confirm Amendment</button>
                              <button *ngIf="amendmentType!='Cancel'" class="btn btn-outline-success c-width-100px shadow " [disabled]="confirmDisabled" (click)="reschedule()">Confirm Amendment</button>

                            <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                       
                            </div>
                            <mat-divider></mat-divider>
                            <span  class="d-flex justify-content-start"><strong>Note: </strong><p>Do you really want to amend? Please note these changes are irreversible and might take some time to process.</p></span>

                          </div>
                          </div>
                  </div>
              </div>


              <div class="modal " id="myMod"  [style.display]="showAmendProcess ? 'block' : 'none'" >
                <div class="modal-dialog" >
                    <div class="modal-content " >
                        <div class="modal-header title">
                          <h4  class="modal-title">
                          Amendment Items ({{AmendProcessDetail?.uuId}})
                          <!-- {{'Air Item Details for '+PassengerDetail?.title+' '+PassengerDetail?.firstName+' '+PassengerDetail?.lastName}} -->
                          </h4>

                          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                          </div>
                          <div class="modal-body" *ngIf="showAmendProcess" style="overflow: auto;max-height: 60vh;">
                           
                          <div class="col-md-12 mt-3 mb-2 "  *ngFor="let ItinerariesamendAir of amendAirItineraries.repriceData.flightDetailsList;let i=index">
                      <div class="title col-md-12" style="max-height: 40px;text-align: left;padding-left: 6px;">Item {{i+1}}. {{ItinerariesamendAir?.fromAirport+' - '+ItinerariesamendAir?.toAirport  }}</div>
                            <table class="styled-tables col-md-12" style="text-align: left;">
                              <thead>
                                <tr >
                                  <!-- Dynamic headers based on tableHeaders array -->
                                  <th style="padding: 8px;  text-align: center;"></th>
                                  <th style="padding: 8px;  text-align: center;">Current Value	</th>
                                  <th style="padding: 8px;  text-align: center;">New Value</th>
                                 
      
      
                                </tr>
                              </thead>
                              <tbody>
                                <!-- Iterate through dynamic data rows -->
                                <tr>
                                  <td   style="width: 40%;padding: 8px;">{{'Airline'}}</td>
                                  <td  style="padding: 8px;">{{fligthNameFilter(ItinerariesamendAir?.currentValue?.carrierName)}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="airline" readonly [ngModel]="fligthNameFilter(ItinerariesamendAir.carrierName)"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'From'}}</td>
                                  <td  style="padding: 8px;">{{cityFilter(ItinerariesamendAir?.currentValue?.fromAirport)}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="from" readonly [ngModel]="cityFilter(ItinerariesamendAir.fromAirport)"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'To'}}</td>
                                  <td  style="padding: 8px;">{{cityFilter(ItinerariesamendAir?.currentValue?.toAirport)}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="to" readonly [ngModel]="cityFilter(ItinerariesamendAir.toAirport)"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'From Terminal	'}}</td>
                                  <td  style="padding: 8px;">{{ItinerariesamendAir?.currentValue?.fromTerminal}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="fromTerminal" [(ngModel)]="ItinerariesamendAir.fromTerminal" ></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'To Terminal	'}}</td>
                                  <td  style="padding: 8px;">{{ ItinerariesamendAir?.currentValue?.toTerminal}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="toTerminal" [(ngModel)]="ItinerariesamendAir.toTerminal"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Flight No'}}</td>
                                  <td  style="padding: 8px;">{{ItinerariesamendAir?.currentValue?.flightNumber}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="flightNo" [(ngModel)]="ItinerariesamendAir.flightNumber"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Departure Time (dd/MM/yyyyTHH:mm)'}}</td>
                                  <td  style="padding: 8px;">{{formatDate(ItinerariesamendAir?.currentValue?.schDepartureTime)}}</td>
                                  <td  style="padding: 8px;">
                                    
                                    <!-- <input type="text" class="form-control" name="departure" [(ngModel)]="ItinerariesamendAir.schDepartureTime"> -->
                                    <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
                                      <mat-label>From</mat-label>
                                      <mat-hint>MM/DD/YYYY</mat-hint>
                                      <!-- (dateChange)="searchByOrderId() -->
                                      <input matInput [ngxMatDatetimePicker]="pickeR" readonly  placeholder="Choose a date" [(ngModel)]="ItinerariesamendAir.schDepartureTime" 
                                         [disabled]="disabled">
                                      <button mat-icon-button matSuffix (click)="pickeR.open()">
                                        <mat-icon>calendar_today</mat-icon>
                                      </button> 
                                      <ngx-mat-datetime-picker #pickeR [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                                        [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                                        [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                                        [disableMinute]="disableMinute" [hideTime]="hideTime">
                                      </ngx-mat-datetime-picker> 
                                    </mat-form-field>
                                   </td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Arrival Time (dd/MM/yyyyTHH:mm)'}}</td>
                                  <td  style="padding: 8px;">        {{ formatDate( ItinerariesamendAir?.currentValue?.schArrivalTime)}}
                                  </td>
                                  <td  style="padding: 8px;">
                                    <!-- <input type="text" class="form-control" name="arrival" [ngModel]="ItinerariesamendAir.schArrivalTime"> -->
                                    <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
                                      <mat-label>From</mat-label>
                                      <mat-hint>MM/DD/YYYY</mat-hint>
                                      <!-- (dateChange)="searchByOrderId() -->
                                      <input matInput [ngxMatDatetimePicker]="picke" readonly  placeholder="Choose a date" [(ngModel)]="ItinerariesamendAir.schArrivalTime" 
                                         [disabled]="disabled">
                                      <button mat-icon-button matSuffix (click)="picke.open()">
                                        <mat-icon>calendar_today</mat-icon>
                                      </button> 
                                      <ngx-mat-datetime-picker #picke [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                                        [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                                        [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                                        [disableMinute]="disableMinute" [hideTime]="hideTime">
                                      </ngx-mat-datetime-picker> 
                                    </mat-form-field>
                                  </td>
                                </tr>
                               
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Airline PNR		'}}</td>
                                  <td  style="padding: 8px;">{{PassengerDetail?.pnr}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="pnr" [(ngModel)]="PassengerDetail.pnr"></td>
                                </tr>
                               
                                <tr>
                                  <td  style="padding: 8px;">{{'CRS PNR'}}</td>
                                  <td  style="padding: 8px;">{{this.PassengerDetail?.csrPNR}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="crsPnr" [(ngModel)]="PassengerDetail.csrPNR"></td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Ticket Number	'}}</td>
                                  <td  style="padding: 8px;">{{PassengerDetail?.ticketNumber==='0'?(''):PassengerDetail?.ticketNumber===0?(''):PassengerDetail?.ticketNumber?(PassengerDetail?.ticketNumber):''}}</td>
                                  <td  style="padding: 8px;"><input type="text" class="form-control" name="ticket" [ngModel]="PassengerDetail?.ticketNumber==='0'?(''):PassengerDetail?.ticketNumber===0?(''):PassengerDetail?.ticketNumber?(PassengerDetail?.ticketNumber):''"></td>
                                </tr> -->
                              <ng-container  *ngIf="AmendProcessDetail?.type==='Reschedule'" >
                            <ng-container  *ngFor="let passenger of ItinerariesamendAir.classes ; let i=index" >
                              <tr>
                                <th style="padding: 8px;  text-align: start;"><strong>{{i+1}}.</strong> {{passenger.title}} {{passenger.firstName}} {{passenger.lastName}}</th>

                              </tr>
                              <tr>
                                <th style="padding: 8px;  text-align: start;">Ticket Number</th>
  
                                    <td  style="padding: 8px;"><input type="text" (keypress)="onlyNumberKey($event)" class="form-control" name="fromTerminal" [(ngModel)]="passenger.ticketNumber" ></td>
                              </tr>
                             
                                <ng-container  *ngFor="let taxs of passenger.fareDetails.passengerBookingClasses" >
                                <tr *ngFor="let tax of taxs.fareDetailsPerPassengerType.taxes">
                                  <td  style="padding: 8px;">{{tax?.key}}</td>
                                  <td  style="padding: 8px;">{{tax?.value}}</td>
                                  <td  style="padding: 8px;">
                                    <input type="text" (keypress)="onlyNumberKey($event)" class="form-control"  [(ngModel)]="tax.tempValue" (input)="ChangeTotalTax()">
                                  </td>
                                </tr>
                                <tr *ngIf="AmendProcessDetail?.type==='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Final Tax	'}}</td>
                                  <td  style="padding: 8px;">{{taxs?.currentValue?.fareDetailsPerPassengerType?.finalTax}}</td>
                                  <td  style="padding: 8px;"><input type="text" (keypress)="onlyNumberKey($event)" readonly class="form-control"  [(ngModel)]="taxs.totaltaxes"></td>
                                </tr>
                                <tr *ngIf="AmendProcessDetail?.type==='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Base Fare	'}}</td>
                                  <td  style="padding: 8px;">{{taxs?.currentValue?.fareDetailsPerPassengerType?.baseFare}}</td>
                                  <td  style="padding: 8px;"><input type="text" (keypress)="onlyNumberKey($event)" class="form-control"  [(ngModel)]="taxs.fareDetailsPerPassengerType.baseFare" (input)="ChangeTotalTax()"></td>
                                </tr>
                              </ng-container>
                            </ng-container >
                             
                          </ng-container >
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Cabin class	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Currency	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                
                               
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Fuel Surcharge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Congestion Charge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!--  -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'UDF Charge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                 <tr>
                                  <td  style="padding: 8px;">{{'JN Tax	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'SBC Tax	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'KKC Tax	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Airline GST	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'UDF Charge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'P2	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'YM'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'SG'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'L7'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Meal Extra Charge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Seat Extra Charge'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Baggage Extra Charge'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'OC Charge	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'OB (Passthrough Fee)	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <tr *ngIf="AmendProcessDetail?.type==='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Supplier Amendment Fee	'}}</td>
                                  <td  style="padding: 8px;">{{PassengerDetail?.feeRules}}</td>
                                  <td  style="padding: 8px;">
                                    <input type="text" class="form-control" name="crsPnr" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeRules"></td>
                                </tr>
                                <tr *ngIf="AmendProcessDetail?.type==='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Supplier Amendment Fee Markup'}}</td>
                                  <td  style="padding: 8px;">{{'0'}}</td>
                                  <td  style="padding: 8px;">
                                    <input type="text" class="form-control" name="crsPnr" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeMarkup"></td>
                                </tr>
                                <tr *ngIf="AmendProcessDetail?.type!='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Supplier Amendment Fee	'}}</td>
                                  <td  style="padding: 8px;">{{PassengerDetail?.feeRules}}</td>
                                  <td  style="padding: 8px;">
                                    <input type="text" class="form-control" name="crsPnr" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeRules"></td>
                                </tr>
                                <tr *ngIf="AmendProcessDetail?.type!='Reschedule'" >
                                  <td  style="padding: 8px;">{{'Supplier Amendment Fee Markup'}}</td>
                                  <td  style="padding: 8px;">{{'0'}}</td>
                                  <td  style="padding: 8px;">
                                    <input type="text" class="form-control" name="crsPnr" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeMarkup"></td>
                                </tr>
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Booking Fee	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Baggage Extra Charge'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                <!-- <tr>
                                  <td  style="padding: 8px;">{{'Transaction Fee	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'GST'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'GST2'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'GST3'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Reseller Amendment Fee	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'Commission/Discount (Gross)	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr>
                                <tr>
                                  <td  style="padding: 8px;">{{'TDS	'}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                  <td  style="padding: 8px;">{{''}}</td>
                                </tr> -->
                                



                              </tbody>
                            </table>

                            

                            

                            <!-- <div class="title col-md-12 mt-2" style="max-height: 40px;text-align: left;padding-left: 6px;">{{'Reseller Balance'}}</div> -->

                            <!-- <table class="styled-tables ">
                              <thead>
                              </thead>
                              <tbody>
                                <tr >
                                  <td  class="name-type" style="padding: 8px;width: 50%;">Balance Amount	
                                  </td>
                                  <td  style="padding: 8px; " style="text-align: left;padding-left: 8px;">
                                    <div class="col-md-12">
                                    <strong>Your Balance: </strong>INR 0
                                  </div>
                                  <div class="col-md-12">

                                   <strong> Credit Balance:</strong> INR 0
                                   </div>
                                  </td>
                                 
                                </tr>
                                
                              </tbody>
                            </table> -->
                          </div>
                          <div class="title col-md-12 mt-2" style="max-height: 40px;text-align: left;padding-left: 6px;">{{'Amount Details'}}</div>

                          <table class="styled-tables ">
                            <thead>
                            </thead>
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
                              <!-- <tr >
                                <td  class="name-type" style="padding: 8px;width: 50%;">Refund TDS	</td>
                                <td  style="padding: 8px;">{{''}}</td>
                               
                              </tr> -->
                              <tr >
                                <!-- Display structured data -->
                                <td class="name-type"  style="padding: 8px;width: 50%;">Amendment Type	</td>
                                <td  style="padding: 8px;">{{AmendProcessDetail?.type}}</td>
                               
                              </tr>
                              <tr *ngIf="AmendProcessDetail?.type!='Reschedule'"  class="mt-3">
                                <!-- Display structured data -->
                                <td class="name-type"  style="padding: 8px;">Amount To Charge	</td>
                                <td  style="padding: 8px;">{{totalPrice(PassengerDetail.feeRules,PassengerDetail.feeMarkup)}}</td>
                               
                              </tr>
                              <tr *ngIf="AmendProcessDetail?.type==='Reschedule'"  class="mt-3">
                                <!-- Display structured data -->
                                <td class="name-type"  style="padding: 8px;">Amount To Charge	</td>
                                <td  style="padding: 8px;">{{totalPrice(PassengerDetail.feeRules,PassengerDetail.feeMarkup)+TotalRescheduleAmount}}</td>
                               
                              </tr>
                              
                            </tbody>
                          </table>
                        </div>

                            <div class="modal-footer">
                             
                              <button *ngIf="AmendProcessDetail?.type!='Reschedule'" class="btn btn-outline-success c-width-100px shadow " (click)="amendProcess()" [disabled]="disabled" >Amend</button>
                              <button *ngIf="AmendProcessDetail?.type==='Reschedule'" class="btn btn-outline-success c-width-100px shadow " (click)="amendRescheduledProcess()" [disabled]="disabled" >Amend</button>

                            <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                       
                            </div>
                            
                          </div>
                  </div>
              </div>


              <div class="popup-overlay" *ngIf="showPopup">
                <div class="popup-container">
                  <div class="col-md-12 row">
                    <div class="col-md-6 d-flex justify-content-start">
                    <h4 >Miscellaneous Data</h4>
                  </div>
                    <div class="col-md-6 d-flex justify-content-end"><button  type="button" class="close" data-dismiss="modal" (click)="closeMiscellaneous()">&times;</button>
                    </div>
                  </div>
                  <div class="col-md-12 row">
                    <mat-form-field *ngIf="showPopup" class="col-md-6" appearance="outline">
                      <mat-label>Miscellaneous Data</mat-label>
                      <mat-select [formControl]="serviceControl" multiple (selectionChange)="onMultiSelect()">
                        <mat-option *ngFor="let service of serviceData" [value]="service">
                          {{ service.type }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!-- <mat-form-field class="col-md-6" appearance="outline">
                      <mat-label>Ticket Number</mat-label>
                      <input matInput type="text"  name="ticket"  autocomplete="off" >
                    </mat-form-field> -->
                  </div>
                  <div class="col-md-12 row" style="height: 350px;overflow: auto;">
                  <div class="col-md-6" *ngFor="let itinerary of miscellaneousRequest.orderPassengerDetails.seatMeal.seatMeal;let i=index">
                    <strong class="pt-2 d-flex justify-content-start">{{i+1}}. {{itinerary.from}}-{{itinerary.to}} </strong>

                 
<div class="col-md-12 d-flex justify-content-start">
                  <!-- <h5>Selected Miscellaneous</h5> -->
                </div>
                  <table class="styled-table">
                    <!-- <thead>
                      <tr>
                        <th>Number</th>
                        <th>Code</th>
                        <th>Type</th>
                      </tr>
                    </thead> -->
                    <tbody>
                      <tr *ngFor="let service of selectedServices">
                        <td>
                          <span style="font-weight:500;font-size: 16px;">{{ service.type }}</span></td>
                        <td >
                          <!-- <mat-form-field  appearance="outline"> -->
                            <mat-label  class="col-md-12"> {{service.number}}	</mat-label>

                            <input *ngIf="service.number==='Seat Number'" [readonly]="itinerary.seatUpdated" class="col-md-12" matInput type="text"  [(ngModel)]="itinerary.seatNumber" >
                            <input *ngIf="service.number==='Meal Code'" [readonly]="itinerary.mealUpdated" class="col-md-12" matInput type="text"   [(ngModel)]="itinerary.mealPreferences"  >
                            <input *ngIf="service.number==='Baggage Weight'" [readonly]="itinerary.baggageSsrUpdated" class="col-md-12" matInput type="text"   [(ngModel)]="itinerary.baggageSsr"  >
                            <input *ngIf="service.number==='SSRCode'" [readonly]="itinerary.specialSsrUpdated" class="col-md-12" matInput type="text"   [(ngModel)]="itinerary.specialSsr"  >
                            <input *ngIf="service.type==='EMD'" [readonly]="itinerary.emdUpdated" class="col-md-12" matInput type="text"   [(ngModel)]="itinerary.emd"  >
                            <!-- <input *ngIf="service.number==='FastForward Code'" class="col-md-12" matInput type="text"   [(ngModel)]=""  > -->
                            
                            <!-- </mat-form-field> -->
                         </td>
                        <td *ngIf="userType!='EMPLOYEE'">
                          <!-- <mat-form-field  appearance="outline"> -->
                            <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> Amount	</mat-label>
                            <input *ngIf="service.number==='Seat Number'" [readonly]="itinerary.seatUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.seatBasePrice"  >
                            <input *ngIf="service.number==='Meal Code'" [readonly]="itinerary.mealUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.mealBasePrice"  >
                            <input *ngIf="service.number==='Baggage Weight'" [readonly]="itinerary.baggageSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.baggageSsrBasePrice"  >
                            <input *ngIf="service.number==='SSRCode'"  [readonly]="itinerary.specialSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.specialSsrBasePrice"  >
                            <input *ngIf="service.type==='EMD'"  [readonly]="itinerary.emdUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.emdBasePrice"  >
                            <!-- </mat-form-field> -->
                        </td>
                        <td  style="min-width: 150px;">
                          <!-- <mat-form-field  appearance="outline"> -->
                            <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> FOP	</mat-label>

                            <mat-select  *ngIf="service.number==='Seat Number'" class="col-md-12 select-box" [(ngModel)]="itinerary.seatFop" >
                              <mat-option [disabled]="itinerary.seatUpdated"  value="C">Cash</mat-option>
                              <mat-option [disabled]="itinerary.seatUpdated" value="O">Original</mat-option>
                            </mat-select>
                            <mat-select *ngIf="service.number==='Meal Code'" class="col-md-12 select-box"  [(ngModel)]="itinerary.mealFop" >
                              <mat-option [disabled]="itinerary.mealUpdated"  value="C">Cash</mat-option>
                              <mat-option [disabled]="itinerary.mealUpdated" value="O">Original</mat-option>
                            </mat-select>
                            <mat-select *ngIf="service.number==='Baggage Weight'" class="col-md-12 select-box"  [(ngModel)]="itinerary.baggageSsrFop" >
                              <mat-option [disabled]="itinerary.baggageSsrUpdated"  value="C">Cash</mat-option>
                              <mat-option [disabled]="itinerary.baggageSsrUpdated" value="O">Original</mat-option>
                            </mat-select>
                            <mat-select *ngIf="service.number==='SSRCode'" class="col-md-12 select-box"  [(ngModel)]="itinerary.specialSsrFop" >
                              <mat-option [disabled]="itinerary.specialSsrUpdated"  value="C">Cash</mat-option>
                              <mat-option [disabled]="itinerary.specialSsrUpdated" value="O">Original</mat-option>
                            </mat-select>
                            <mat-select *ngIf="service.type==='EMD'" class="col-md-12 select-box"  [(ngModel)]="itinerary.emdFop" >
                              <mat-option [disabled]="itinerary.emdUpdated"  value="C">Cash</mat-option>
                              <mat-option [disabled]="itinerary.emdUpdated" value="O">Original</mat-option>
                            </mat-select>
                           
                            

                          
                            <!-- </mat-form-field> -->
                        </td>
                        
                        <td *ngIf="userType!='EMPLOYEE'">
                          <!-- <mat-form-field  appearance="outline"> -->
                            <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> Markup	</mat-label>
                            <input *ngIf="service.number==='Seat Number'" [readonly]="itinerary.seatUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.seatMarkup"  >
                            <input *ngIf="service.number==='Meal Code'" [readonly]="itinerary.mealUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.mealMarkup"  >
                            <input *ngIf="service.number==='Baggage Weight'" [readonly]="itinerary.baggageSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.baggageSsrMarkup"  >
                            <input *ngIf="service.number==='SSRCode'"  [readonly]="itinerary.specialSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.specialSsrMarkup"  >
                            <input *ngIf="service.type==='EMD'"  [readonly]="itinerary.emdUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.emdMarkup"  >
                            <!-- </mat-form-field> -->
                        </td>
                        <td *ngIf="miscellaneousRequest.source==='GALELIO'">
                          <!-- <mat-form-field  appearance="outline"> -->
                            <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> Ticket Number	</mat-label>
                            <input *ngIf="service.number==='Seat Number'" [readonly]="itinerary.seatUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.seatTicketNumber"  >

                            <input *ngIf="service.number==='Meal Code'" [readonly]="itinerary.mealUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.mealTicketNumber"  >
                            <input *ngIf="service.number==='Baggage Weight'" [readonly]="itinerary.baggageSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"  [(ngModel)]="itinerary.baggageSsrTicketNumber"  >
                            <input *ngIf="service.number==='SSRCode'"  [readonly]="itinerary.specialSsrUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.specialSsrTicketNumber"  >
                            <input *ngIf="service.type==='EMD'"  [readonly]="itinerary.emdUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="itinerary.emdTicketNumber"  >
                            <!-- </mat-form-field> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
                  <button  class="save-button" mat-raised-button color="primary" (click)="updateMiscellaneous()" [disabled]="disabledMiscellaneous||selectedServices.length===0||isSaveDisabled(miscellaneousRequest.orderPassengerDetails.seatMeal.seatMeal)">Save</button>
                </div>
              </div>
              
              <!-- Multi-select component -->
              
              <p-dialog header="Invoice" [modal]="true" [maximizable]="true" [(visible)]="pdfUrl" [style]="{ width: '55rem',height:'100%'  }">
                  <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="700px" ></iframe>
            </p-dialog>




            <p-sidebar [(visible)]="showSidebar" position="left" styleClass="col-md-8" >
              <ng-template pTemplate="header">
                <strong class="col-md-11 font-semibold text-xl">Advanced Pricing</strong>
                  
                <!-- pTemplate="headless" -->
              
            </ng-template>
<div class="d-flex justify-content-start">         
      <mat-checkbox color="primary" [(ngModel)]="showInput">Add Adhoc Markup</mat-checkbox>
</div>
           <span *ngIf="showInput">
            <span *ngFor="let flightsItem of flightData.airItineraries;let flightsItemIndex = index" >
              
              <strong ><img class="carrier-logo" [src]="flightlogoFilter(flightsItem?.flightDetails?.flightDetailsList[0]?.carrierName)"  alt="">
                {{fligthNameFilter(flightsItem?.flightDetails?.flightDetailsList[0]?.carrierName)+"-"+flightsItem?.flightDetails?.flightDetailsList[0]?.flightNumber}} {{cityFilter(flightsItem?.flightDetails?.flightDetailsList[0]?.fromAirport)+"-"+cityFilter(flightsItem?.flightDetails?.flightDetailsList[flightsItem?.flightDetails?.flightDetailsList.length - 1]?.toAirport)}}</strong>
            <table   class="styled-tables col-md-12" >
              <thead>
                <tr >
                  <th style="padding: 8px;  text-align: center;">Base   </th>
                  <th style="padding: 8px;  text-align: center;">Tax  </th>
                  <th style="padding: 8px;  text-align: center;">Fee  </th>
          
          
          
                </tr>
              </thead>
              
               
              <tbody  *ngFor="let traveller of travellerArray(travellerDetail.adult,flightsItem?.externalMarkUpData?.advancedPricingList,'ADT');let i=index" >
                <tr >
                  <td class="value-cell"><strong>Adult {{i+1}}</strong> {{flightsItem?.flightDetails?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetails?.flightDetailsList[flightsItem?.flightDetails?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetails?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetails?.flightDetailsList[0]?.flightNumber}}</td>
                  <td class="value-cell"></td>
                  <td class="value-cell"></td>
                  </tr>
                <tr >
                 
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'baseAmt', i)" readonly [ngModel]="traveller?.baseAmt"  type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'taxAmt', i)"  [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'feeAmt', i)" readonly  [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                
                
          
                </tr>
              </tbody>
          
                <tbody *ngFor="let traveller of travellerArray(travellerDetail.child,flightsItem?.externalMarkUpData?.advancedPricingList,'CHD');let i=index" >
          
                <tr >
                  <td class="value-cell"><strong>Child {{i+1}}</strong> {{flightsItem?.flightDetails?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetails?.flightDetailsList[flightsItem?.flightDetails?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetails?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetails?.flightDetailsList[0]?.flightNumber}}</td>
                  <td class="value-cell"></td>
                  <td class="value-cell"></td>
                  </tr>
                <tr >
                 
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'baseAmt', i+travellerDetail.adult)" readonly [ngModel]="traveller?.baseAmt"  type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'taxAmt', i+travellerDetail.adult)" [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'feeAmt', i+travellerDetail.adult)" readonly [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                
          
                </tr>
              </tbody>
          <tbody *ngFor="let traveller of travellerArray(travellerDetail.infantCount,flightsItem?.externalMarkUpData?.advancedPricingList,'INF'); let i=index">
            <tr >
              <td class="value-cell"><strong>Infant {{i+1}}</strong> {{flightsItem?.flightDetails?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetails?.flightDetailsList[flightsItem?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetails?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetails?.flightDetailsList[0]?.flightNumber}}</td>
              <td class="value-cell"></td>
              <td class="value-cell"></td>
              </tr>
                <tr >
                 
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'baseAmt', i+travellerDetail.adult+travellerDetail.child)" readonly [ngModel]="traveller?.baseAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'taxAmt', i+travellerDetail.adult+travellerDetail.child)"   [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                  <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'feeAmt', i+travellerDetail.adult+travellerDetail.child)"  readonly [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
                
          
                </tr>
                
                
              </tbody>
            
            </table>
            
            <br>
            </span>
          </span>
            <ng-template pTemplate="footer">
            <div class=" d-flex justify-content-end">
            <button *ngIf="showInput" mat-stroked-button color="primary" (click)="updateTicketData()">Update</button>

            <!-- <mat-checkbox style="margin-left: 4px;margin-right: 40px;" color="primary" [(ngModel)]="pricing">Pricing</mat-checkbox> -->
            <button *ngIf="!showInput" mat-stroked-button color="primary" (click)="downloadAgentTicket('C','P')">Download With Pricing</button>

            <button *ngIf="!showInput" mat-stroked-button color="primary" (click)="downloadAgentTicket('C','W')">Download Without Pricing</button>
          <!-- <button mat-flat-button style="color: white;background-color: #1876D0;" (click)="submit()">Close</button> -->
            </div>
           </ng-template>
          </p-sidebar>